declare namespace $ {

	type $mol_image__uri_bog_bzrl_app_hero_1 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_hero['icon_uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_paragraph__title_bog_bzrl_app_hero_2 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_hero['title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_bzrl_app_hero_3 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_hero['description'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_minor__click_bog_bzrl_app_hero_4 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_hero['action'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_bzrl_app_hero_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_bzrl_app_hero_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_image__uri_bog_bzrl_app_hero_7 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_hero['media_uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_view__sub_bog_bzrl_app_hero_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_bzrl_app_hero extends $mol_view {
		variant( ): string
		icon_uri( ): string
		Icon( next?: $mol_image ): $mol_image
		title( ): string
		Title( ): $mol_paragraph
		description( ): string
		Description( ): $mol_paragraph
		action( next?: any ): any
		action_label( ): string
		Action( ): $mol_button_minor
		Content( ): $mol_view
		media_uri( ): string
		Media_image( ): $mol_image
		Media( next?: $mol_view ): $mol_view
		attr( ): ({ 
			'bog_bzrl_app_hero_variant': ReturnType< $bog_bzrl_app_hero['variant'] >,
		})  & ReturnType< $mol_view['attr'] >
		sub( ): readonly(any)[]
	}
	
	export class $bog_bzrl_app_hero_promo extends $bog_bzrl_app_hero {
		variant( ): string
		title( ): string
		description( ): string
		action_label( ): string
		media_uri( ): string
	}
	
	export class $bog_bzrl_app_hero_privacy extends $bog_bzrl_app_hero {
		variant( ): string
		title( ): string
		description( ): string
		icon_uri( ): string
	}
	
	export class $bog_bzrl_app_hero_let extends $bog_bzrl_app_hero {
		title( ): string
		description( ): string
		action_label( ): string
	}
	
	type $mol_image__uri_bog_bzrl_app_hero_team_1 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_hero_team['photo'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_paragraph__title_bog_bzrl_app_hero_team_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_bzrl_app_hero_team_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_bzrl_app_hero_team_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_bzrl_app_hero_team extends $mol_view {
		photo( ): string
		Photo( ): $mol_image
		Title( ): $mol_paragraph
		Description( ): $mol_paragraph
		Content( ): $mol_view
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=hero.view.tree.d.ts.map